import { useState } from 'react';
import { useUnit } from 'effector-react';
import clsx from 'clsx';
import { $profileFeatureStore, $profileStore } from '@lib/store';
import { ChangePasswordModal } from '../widgets';
import { Button, Icon, Text } from '@shared/widgets';
import ShieldIcon from '@assets/icons/shield.svg';
import ChevronIcon from '@assets/icons/chevron.svg';

export const UserSecurityOptions = () => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);
  const profileStore = useUnit($profileStore.store);

  const [options, setOptions] = useState<boolean>(true);
  const [changePassword, setChangePassword] = useState<boolean>(false);

  if (!profileFeatureStore.data?.profileSettings.changeOwnPassword) return null;
  return (
    <div className='mb-2 pb-2 border-b-gray-200 border-b last:border-b-0 last:mb-0 last:pt-0'>
      <div className='flex items-center min-h-12 px-0 py-4 cursor-pointer' onClick={() => setOptions((prev) => !prev)}>
        <div
          className={clsx(
            'flex-none flex items-center justify-center transition ease-out mr-4',
            options ? 'text-primary' : 'text-slate  dark:text-white',
          )}
        >
          <Icon icon={<ShieldIcon />} color='inherit' />
        </div>
        <Text className='flex-auto'>Security options</Text>
        <div className={clsx('flex items-center justify-center text-center transition ease-out', options && 'rotate-180')}>
          <Icon icon={<ChevronIcon />} className='-rotate-90' />
        </div>
      </div>
      <div className={clsx(!options ? 'hidden' : 'block pt-3')}>
        <div className='mb-5'>
          <Button color='outlined' fullWidth onClick={() => setChangePassword(true)}>
            Change password
          </Button>
          <ChangePasswordModal isOpen={changePassword} onClose={() => setChangePassword(false)} profileId={profileStore.data!.id} />
        </div>
      </div>
    </div>
  );
};
